import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

import { Box, Text, media } from '@redriverpress/system'

import GenresSidebarSkeleton from '../../../common/components/GenresSidebarSkeleton'
import useGenres from '../../hooks/useVideoGenres'

const GenreLink = styled(NavLink)`
  background: white;
  border-radius: ${props => props.theme.radii.rounded};
  display: flex;
  font-size: ${props => props.theme.fontSizes[0]};
  padding: ${props => props.theme.space[2]};
  margin-bottom: ${props => props.theme.space[2]};
  text-decoration: none; /* override default link style */

  ${media.lg`
    font-size: ${props => props.theme.fontSizes[1]};
    padding: ${props => props.theme.space[3]};
  `}

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${props => props.theme.colors.blue500};
  }

  &.active {
    background: linear-gradient(
      to left,
      ${props => props.theme.colors.blue500} 0 0.5rem,
      white 0.5rem 100%
    );
  }
`

export default function GenresSidebar() {
  const { isLoading, genres } = useGenres()

  return isLoading ? (
    <GenresSidebarSkeleton />
  ) : (
    <Box as='nav' aria-label='Flashcard sections'>
      {genres.map(genre => (
        <GenreLink
          key={genre.id}
          exact={genre.slug === ''}
          to={`/videos/${genre.slug}`}
          isActive={(match, location) => !!match && location.search === ''}
        >
          <Text mt={[null, null, -1, 0]}>
            <Text as='span' fontWeight={600}>
              {genre.title}
            </Text>
            <br />
            <Text as='span' color='gray900'>
              {genre.videosCount.toLocaleString()} ESL videos
            </Text>
          </Text>
        </GenreLink>
      ))}
    </Box>
  )
}
